/**
 * Notification Settings (Angular `notification-assignment`).
 * Sidebar entry: "Notification Settings" → `/notification-settings` in Angular.
 */

export const LIBERTY_ROLES = {
  EXTERNAL_INSURANCE: 'External Insurance',
  ROLE_ADMIN: 'Liberty Admin',
  ROLE_CUSTOMER_SERVICE: 'Liberty Customer Service',
  ROLE_CUSTOMER_SERVICE_MANAGER: 'Liberty Customer Service Manager',
  ROLE_EXECS: 'Liberty Execs',
  ROLE_LIBERTY_ACCOUNTING: 'Liberty Accounting',
  ROLE_LIBERTY_DEFAULTS: 'Liberty Default',
  ROLE_LIBERTY_FIN_MGR: 'Liberty Finance Manager',
  ROLE_LIBERTY_SALES: 'Liberty Sales',
  ROLE_UNDERWRITER: 'Liberty Underwriter',
  ROLE_REFUND_APPROVAL: 'Liberty Refund Approval',
} as const

export type LibertyRoleKey = keyof typeof LIBERTY_ROLES

export interface NotificationAction {
  an_id: number
  notification_type: string
  /** Array of role keys (as stored) */
  roles?: string[]
  /** Human-readable role list from API (often concatenated without separators) */
  role_added?: string
}

export type NotificationSortKey = 'notification_type'
export type SortDirection = 'asc' | 'desc'

export interface NotificationListParams {
  orderBy?: NotificationSortKey
  sortBy?: SortDirection
}

export interface NotificationSubmitPayload {
  notification_type: string
  roles: string[]
}
